import React, { useContext } from "react";
import DashBoardLayout from "../components/DashBoardLayout";
import DashBoardQaLayout from "../components/DashBoardQaLayout";
import DashBoardConsultantsLayout from "../components/DashBoardConsultantsLayout";
import NavSub from "../components/NavSub";
import { AuthContext } from "../context/AuthContext";
import isGuestUser, { hasRole } from "../utils/guestUser";

function Dashboard() {
  const { userData, isLoading, authError } = useContext(AuthContext);
  const userRole = userData?.[0]?.DR_Name;

  if (isLoading) {
    return <div style={{ padding: "2rem", textAlign: "center" }}>Loading...</div>;
  }

  if (authError) {
    return (
      <>
        <NavSub />
        <div style={{ padding: "2rem", color: "red", textAlign: "center" }}>{authError}</div>
      </>
    );
  }

  if (isGuestUser(userData?.[0]?.DRM_ID)) {
    return (
      <>
        <NavSub />
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "70vh",
          gap: "12px",
          color: "#50145A",
          fontFamily: "Poppins, sans-serif",
        }}>
          <div style={{ fontSize: "48px" }}>👤</div>
          <div style={{ fontSize: "20px", fontWeight: 700 }}>Guest Access</div>
          <div style={{ fontSize: "14px", color: "#777", textAlign: "center", maxWidth: "380px" }}>
            You are logged in as a guest. Dashboard access is not available for guest users.
            Please contact your administrator to request full access.
          </div>
        </div>
      </>
    );
  }

  let layoutComponent;
  if (
    hasRole(userRole, "Admin") ||
    hasRole(userRole, "Super Admin") ||
    hasRole(userRole, "Managing Director") ||
    hasRole(userRole, "Process Lead") ||
    hasRole(userRole, "Department Lead")
  ) {
    layoutComponent = <DashBoardLayout />;
  } else if (hasRole(userRole, "Quality Consultant")) {
    layoutComponent = <DashBoardQaLayout />;
  } else if (hasRole(userRole, "Consultant")) {
    layoutComponent = <DashBoardConsultantsLayout />;
  } else {
    layoutComponent = <DashBoardLayout />;
  }

  return (
    <>
      <NavSub />
      {layoutComponent}
    </>
  );
}

export default Dashboard;
